<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="组合名称">
            <a-input :disabled="params.isShow" v-model="data.name" placeholder="请输入组合名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入组合名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="form-row"></a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: ""
};
export default {
  name: "hp-manager-page-productUnion-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getdetailUnion();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getdetailUnion() {
      this.loading = true;
      let result = await api.GetProductUnion({ id: this.params.id });
      if (result) {
        this.data = result;
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        console.log(requestData);
        let data = await api.AddOrUpdateProductUnion(requestData);
        if (data) {
          if (this.params.id > 0) {
            this.$message.success("修改成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$emit("submit-success");
        }

        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/ProductUnion/Add.vue